fx.ns("desktop.calendar", class CalendarMain extends shared.BaseMain {

	constructor() {
		super(new repositories.CalendarRepository());

		fx.set("app", "calendar");
		fx.set("app-device", "app-desktop");
	}

	init() {
		this.views = ["desktop.common.screens.Splash",
			"desktop.common.photoimport.UploadProgress",
			"desktop.common.panels.SelectPhotosPanel",
			"desktop.calendar.CalendarEditor",
            "shared.screens.Saving",
			"desktop.calendar.CalendarTextEditPanel",
			"desktop.calendar.CalendarStartingMonth",
			"desktop.calendar.PhotoChoices",
		];

		fx.enableToolTip();
		this.on("TAB-DOWN", this._toggleGridMode, fx.keyboard);
	}


	onDataEvent(e) {
		super.onDataEvent(e);

		switch (e.type) {
			case "start":
				if (this.model.creationid) {
					this.steps("Splash", "CalendarEditor");
				}
				else {
					fx.set("mode", "creating");

					//this.steps({ view: "Splash", skipPrevious: true }, "PhotoChoices", "CalendarEditor"); // ajouter editeur
					this.steps({ view: "Splash", skipPrevious: true }, "CalendarStartingMonth", "CalendarEditor"); // ajouter editeur
				}
				break;

			case "upload-progress":
				this.popup(new desktop.common.photoimport.UploadProgress(this.model));
				break;

			case "order":
				// ordering is a commitment : the creation has to exist in the account even if the
				// client changed nothing, or the night cleaning takes its photos
				this.model.undelete();

				if (this.readyLeaving(e.type))
					this.model.event("navigate-order", null, 500);
				break;

			// creating wizard keeps its own flow ; standard uses the shared SelectPhotosPanel flow
			case "import-mobile":
				if (fx.get("mode") == "creating")
					this.popup(new shared.popups.EnterPhoneNumber(this.model));
				else
					this._startMobileImport();
				break;

			case "edit-text-calendar":
				this.switchTo("CalendarTextEditPanel", { model : this.model, data: e.detail.data, day: e.detail.day, cellWidth: e.detail.cellWidth, cellHeight: e.detail.cellHeight, });
				break;

			case "mobile-upload-started":
				if (fx.get("mode") == "creating")
					this.popup(null);
				else
					this._showMobileImport();
				break;

			// creating : its wizard waits on -started/-finished, so send does nothing ; standard shows the screen
			case "mobile-upload-send":
				if (fx.get("mode") != "creating")
					this._showMobileImport();
				break;

			case "mobile-upload-finished":
				if (fx.get("mode") == "creating") {
					this.switchTo("CalendarEditor");
				}
				break;

			case "exit-editor":
				if (this.readyLeaving(e.type))
					this.model.event("navigate-exit", null, 500);
				break;

			case "selectphotos":
				this.switchTo("PhotoChoices", {model : this.model, component : e.detail});
				break;

            case "import-google":
				this.popup(new desktop.common.photoimport.GooglePanel(this.model));
				break;

			// validated : "next-step" is a no-op here, the photo screen is not one of the wizard's steps
			case "google-photos-added":
				this.model.event("show-editor");
				break;

			case "show-editor":
				this.actionRequested = ""
				this.switchTo("CalendarEditor");
				break;

			case "screen-saving":
				this.switchTo("Saving");
				break;


		}
	}

	_toggleGridMode(e) {
		fx.get("settings").toggleGridMode();

		e.stopPropagation();
		e.preventDefault();
	}

});